<template>
    <div class="user-actions">
        <button class="btn btn--danger" @click="banOpen = true">Заблокировать</button>
        <button class="btn" @click="unban">Разблокировать</button>
        <button class="btn" @click="resetPassword">Сбросить пароль</button>
        <button class="btn" @click="forceLogout">Force logout</button>
        <button class="btn btn--primary" @click="grantOpen = true">Дать admin-группу</button>
        <button class="btn btn--danger" @click="revokeOpen = true">Убрать admin-группу</button>

        <BanUserDialog v-if="banOpen" :open="banOpen" :user-id="userId" @close="banOpen = false" @done="onDone" />
        <GrantGroupDialog v-if="grantOpen" :open="grantOpen" :user-id="userId" @close="grantOpen = false" @done="onDone" />
        <RevokeGroupDialog v-if="revokeOpen" :open="revokeOpen" :user-id="userId" @close="revokeOpen = false" @done="onDone" />
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { request } from '@/admin/shared/api/httpClient';
import BanUserDialog from './BanUserDialog.vue';
import GrantGroupDialog from './GrantGroupDialog.vue';
import RevokeGroupDialog from './RevokeGroupDialog.vue';

const props = defineProps<{ detail: { id: string } }>();
const banOpen = ref(false);
const grantOpen = ref(false);
const revokeOpen = ref(false);

const userId = (): string => props.detail.id;

async function unban(): Promise<void> {
    if (!confirm('Разблокировать пользователя?')) return;
    await request({ method: 'post', url: `/admin-api/users/${userId()}/unban/`, data: {} });
    onDone();
}

async function resetPassword(): Promise<void> {
    if (!confirm('Отправить письмо для сброса пароля?')) return;
    await request({ method: 'post', url: `/admin-api/users/${userId()}/reset-password/`, data: {} });
    alert('Письмо отправлено.');
}

async function forceLogout(): Promise<void> {
    if (!confirm('Отозвать все сессии пользователя?')) return;
    await request({ method: 'post', url: `/admin-api/users/${userId()}/force-logout/`, data: {} });
    alert('Сессии отозваны.');
}

function onDone(): void {
    banOpen.value = false;
    grantOpen.value = false;
    revokeOpen.value = false;
    // Simple v1 — reload to see updated state.
    window.location.reload();
}
</script>

<style scoped>
.user-actions {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    margin-bottom: 1rem;
}

@media (max-width: 640px) {
    .user-actions .btn { min-height: 2.5rem; }
}
</style>
